import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { SettingsPageShell } from '@/components/settings/settings-page-shell'

type SettingsPlaceholderPageProps = {
  title: string
  description: string
}

export function SettingsPlaceholderPage({ title, description }: SettingsPlaceholderPageProps) {
  return (
    <SettingsPageShell title={title} description={description}>
      <Card>
        <CardHeader>
          <CardTitle>Coming soon</CardTitle>
          <CardDescription>This section is not available yet.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            We&apos;re building this settings area. Check back in a future release.
          </p>
        </CardContent>
      </Card>
    </SettingsPageShell>
  )
}
